<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <!-- Header moderno -->
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Postulaciones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Hidrocarburos</li>
                  <li class="breadcrumb-item active">Postulaciones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>

        <section class="content">
          <div class="container-fluid" v-if="postulaciones !== null">
            <div class="row">
              <div class="col-12">
                <div
                  class="card shadow-sm border-0"
                  :class="$store.getters.getDarkMode ? 'bg-dark' : 'bg-white'"
                >
                  <div
                    class="card-header border-0 py-3"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <h5
                          class="mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-file-alt me-2 text-primary"></i>
                          Gestión de Postulaciones
                        </h5>
                        <p class="mb-0 text-muted small">
                          Administra las postulaciones de hidrocarburos
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card principal moderna -->
            <div class="card border-0 shadow-lg">
              <!-- Header de la card -->
              <div class="card-header bg-geogo text-white">
                <div class="row align-items-center">
                  <div class="col-lg-8">
                    <h5 class="mb-0 text-white font-weight-bold">
                      <i class="fas fa-building"></i>
                      {{ postulaciones.empresa.razon_social }} |
                      <i class="fas fa-calendar-alt me-1"></i>
                      {{ postulaciones.solicitud_diaria.fecha }} |
                      <i class="fas fa-route"></i>
                      {{ postulaciones.solicitud_diaria.sitio.nombre }}
                    </h5>
                  </div>
                  <div class="col-lg-4 text-end">
                    <div class="d-flex justify-content-end">
                      <!-- <button
                        class="btn btn-light btn-lg shadow-sm me-2"
                        @click="saveEstado()"
                        v-if="
                          $store.getters.can(
                            'hidrocarburos.postulaciones.edit'
                          ) && postulaciones.estado == 1
                        "
                      >
                        <i class="fas fa-flag-checkered me-2"></i>
                        Finalizar
                      </button>  -->
                      <button
                        type="button"
                        class="btn btn-light btn-lg shadow-sm text-dark mr-2"
                        @click="getIndex()"
                      >
                        <i class="fas fa-sync-alt fa-spin me-2 text-dark"></i>
                        Actualizar
                      </button>
                      <button
                        type="button"
                        class="btn btn-light btn-lg text-dark"
                        @click="enviarCorreo()"
                        v-if="
                          postulaciones.estado == 2 &&
                            $store.getters.can(
                              'hidrocarburos.postulaciones.enviarCorreo',
                            )
                        "
                      >
                        <i class="fas fa-envelope me-2 text-dark"></i>
                        Enviar Correo
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Barra de progreso mejorada -->
              <div class="bg-light px-4 py-4 mb-3">
                <div class="mb-2">
                  <i class="fas fa-chart-line text-primary me-2"></i>
                  <strong class="text-dark"> Progreso de Postulaciones</strong>
                  <span class="float-right">
                    <h4 class="mb-0 text-primary font-weight-bold d-inline">
                      {{ porcentaje }}%
                    </h4>
                    <small class="text-muted ml-2">Completado</small>
                  </span>
                </div>
                <div class="progress" style="height: 25px; border-radius: 8px">
                  <div
                    class="progress-bar bg-primary progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    :style="'width:' + porcentaje + '%'"
                    :aria-valuenow="porcentaje"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <strong>{{ porcentaje }}%</strong>
                  </div>
                </div>
              </div>

              <div class="card-body p-4">
                <div
                  class="row"
                  v-if="
                    postulaciones.solicitud_diaria.det_solicitudes_diarias
                      .length > 0
                  "
                >
                  <div
                    class="col-md-12 mb-4"
                    v-for="postulacion in postulaciones.solicitud_diaria
                      .det_solicitudes_diarias"
                    :key="postulacion.id"
                  >
                    <!-- Card de postulación moderna -->
                    <div
                      class="card card-outline collapsed-card border-0 shadow-lg mb-4"
                      :class="
                        (postulacion.det_postulaciones.length * 100) /
                          postulacion.cargues <=
                        40
                          ? 'border-left-danger'
                          : (postulacion.det_postulaciones.length * 100) /
                              postulacion.cargues >
                              40 &&
                            (postulacion.det_postulaciones.length * 100) /
                              postulacion.cargues <=
                              99
                          ? 'border-left-warning'
                          : postulacion.det_postulaciones.length ==
                            postulacion.cargues
                          ? 'border-left-success'
                          : 'border-left-secondary'
                      "
                      style="
                        border-left: 6px solid #dee2e6;
                        border-radius: 12px;
                        transition: all 0.3s ease;
                      "
                    >
                      <!-- Header de la card de postulación -->
                      <div
                        class="card-header bg-geogo-top-left"
                        style="border-radius: 12px 12px 0 0"
                      >
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <!-- Hora -->
                            <h5 class="mb-0">
                              <span
                                class="badge badge-primary px-2 py-1 shadow-sm"
                                style="font-size: 1.1rem; border-radius: 8px"
                              >
                                <i class="fas fa-clock me-2"></i>
                                Cita Turne:
                                {{ postulacion?.cita_enturne ?? "Sin definir" }}
                                || Cita Cargue:
                                {{
                                  postulacion.fecha_cita && postulacion.cita
                                    ? postulacion.fecha_cita +
                                      " " +
                                      postulacion.cita
                                    : postulacion.cita
                                    ? postulacion.cita
                                    : "Sin definir"
                                }}
                              </span>
                            </h5>
                          </div>

                          <div class="col">
                            <!-- Badges de información con títulos -->
                            <div
                              class="d-flex flex-wrap align-items-center gap-2"
                            >
                              <div class="d-flex align-items-center">
                                <span
                                  class="badge badge-success px-2 py-1 shadow-sm"
                                  style="font-size: 1.1rem; border-radius: 8px"
                                >
                                  Ruta:
                                  {{
                                    postulaciones.solicitud_diaria.sitio.nombre
                                  }}
                                  <i class="fas fa-arrow-right"></i>
                                  {{
                                    postulacion.sitio_destino?.nombre ??
                                      "Sin Asignar"
                                  }}
                                </span>
                                |
                                <span
                                  class="badge badge-warning px-2 py-1 shadow-sm"
                                  style="font-size: 1.1rem; border-radius: 8px"
                                >
                                  Mercancía: {{ postulacion.producto.nombre }}
                                </span>
                                |
                                <span
                                  class="badge badge-primary px-2 py-1 shadow-sm"
                                  style="font-size: 1.1rem; border-radius: 8px"
                                >
                                  Vehículo:
                                  {{ postulacion.tipo_vehiculo.nombre }}
                                </span>
                                |
                                <span
                                  class="badge badge-secondary px-2 py-1 shadow-sm"
                                  style="font-size: 1.1rem; border-radius: 8px"
                                >
                                  Tipo:
                                  {{
                                    postulacion.adicional
                                      ? "Adicional"
                                      : "Pleno"
                                  }}
                                </span>
                                |
                                <span
                                  class="badge bg-purple px-2 py-1 shadow-sm"
                                  style="font-size: 1.1rem; border-radius: 8px"
                                >
                                  Turno:
                                  {{
                                    postulacion.turno ??
                                      "No tiene turno asignado."
                                  }}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div class="col-auto">
                            <!-- Contadores -->
                            <div
                              class="d-flex align-items-center bg-white rounded-pill px-3 py-2 shadow-sm"
                            >
                              <span
                                class="badge badge-warning me-2 px-3 py-2"
                                >{{ postulacion.cargues }}</span
                              >
                              <i class="fas fa-minus text-muted mx-2"></i>
                              <span
                                class="badge badge-success mx-2 px-3 py-2"
                                >{{
                                  postulacion.det_postulaciones.length
                                }}</span
                              >
                              <i class="fas fa-equals text-muted mx-2"></i>
                              <span class="badge badge-info ms-2 px-3 py-2">{{
                                parseInt(postulacion.cargues) -
                                  parseInt(postulacion.det_postulaciones.length)
                              }}</span>
                            </div>
                          </div>

                          <div class="col-auto">
                            <button
                              type="button"
                              class="btn btn-primary btn-lg shadow-sm"
                              data-card-widget="collapse"
                              style="
                                border-radius: 50%;
                                width: 50px;
                                height: 50px;
                              "
                            >
                              <i class="fas fa-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="card-body">
                        <div
                          class="alert alert-warning"
                          v-if="postulacion.producto.id == 10"
                        >
                          <strong>¡Atención!</strong> Todo vehículo programado
                          para cargar <strong>Fuel Oil </strong>
                          debe presentarse con el tanque lavado y sin presencia
                          de residuos.
                        </div>
                        <table
                          class="table table-bordered table-striped table-hover table-sm"
                        >
                          <thead>
                            <tr>
                              <th>#</th>
                              <th style="width: 20%">Vehículo</th>
                              <th style="width: 20%">Remolque</th>
                              <th>Conductor</th>
                              <th>Estado</th>
                              <th>Orden Cargue</th>
                              <th>Zafiro</th>
                              <th>Adjunto</th>
                              <th>Acción</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(det, detIndex) in det_postulaciones.find(
                                (post) =>
                                  post.id_det_solicitud === postulacion.id,
                              ).data"
                              :key="detIndex"
                            >
                              <td>{{ detIndex + 1 }}</td>
                              <td>
                                <div
                                  v-if="
                                    idActualizar == detIndex &&
                                      det.det_solicitud_diaria_id ==
                                        formActualizar.det_solicitud_diaria_id
                                  "
                                >
                                  <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="formActualizar.vehiculo.placa"
                                    @change="
                                      buscarVehiculos(
                                        postulacion.tipo_ruta,
                                        postulacion.tipo_vehiculo.id,
                                      )
                                    "
                                    :class="
                                      $v.formActualizar.vehiculo.id.$invalid
                                        ? 'is-invalid'
                                        : 'is-valid'
                                    "
                                  />
                                </div>
                                <span v-else>{{ det.vehiculo.placa }}</span>
                              </td>
                              <td>
                                <div v-if="postulacion.tipo_vehiculo_id == 1">
                                  <div
                                    v-if="
                                      idActualizar == detIndex &&
                                        det.det_solicitud_diaria_id ==
                                          formActualizar.det_solicitud_diaria_id
                                    "
                                  >
                                    <input
                                      type="text"
                                      class="form-control form-control-sm"
                                      v-model="formActualizar.remolque.placa"
                                      @change="buscarRemolques()"
                                      v-if="postulacion.tipo_vehiculo_id == 1"
                                      :class="
                                        $v.formActualizar.remolque.id.$invalid
                                          ? 'is-invalid'
                                          : 'is-valid'
                                      "
                                    />
                                  </div>
                                  <span v-else>{{
                                    det.remolque ? det.remolque.placa : ""
                                  }}</span>
                                </div>
                              </td>
                              <td>
                                <div
                                  v-if="
                                    idActualizar == detIndex &&
                                      det.det_solicitud_diaria_id ==
                                        formActualizar.det_solicitud_diaria_id
                                  "
                                >
                                  <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="
                                      formActualizar.conductor.numero_documento
                                    "
                                    @change="buscarConductores()"
                                    :class="
                                      $v.formActualizar.conductor.id.$invalid
                                        ? 'is-invalid'
                                        : 'is-valid'
                                    "
                                  />
                                  {{ formActualizar.conductor.nombres }}
                                  {{ formActualizar.conductor.apellidos }}
                                </div>
                                <span v-else>
                                  {{ det.conductor.numero_documento }}
                                  -
                                  {{ det.conductor.nombres }}
                                  {{ det.conductor.apellidos }}
                                </span>
                              </td>
                              <td>
                                <div>{{ det.nEstado }}</div>
                              </td>
                              <td>
                                <div
                                  v-if="
                                    idActualizar == detIndex &&
                                      det.det_solicitud_diaria_id ==
                                        formActualizar.det_solicitud_diaria_id
                                  "
                                >
                                  <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="formActualizar.orden_cargue"
                                    :class="
                                      $v.formActualizar.orden_cargue.$invalid
                                        ? 'is-invalid'
                                        : 'is-valid'
                                    "
                                  />
                                </div>
                                <span v-else>{{ det.orden_cargue }}</span>
                              </td>
                              <td>
                                <div
                                  v-if="
                                    idActualizar == detIndex &&
                                      det.det_solicitud_diaria_id ==
                                        formActualizar.det_solicitud_diaria_id
                                  "
                                >
                                  <input
                                    type="number"
                                    class="form-control form-control-sm"
                                    v-model="formActualizar.zafiro_id"
                                    :class="
                                      $v.formActualizar.zafiro_id.$invalid
                                        ? 'is-invalid'
                                        : 'is-valid'
                                    "
                                  />
                                </div>
                                <span v-else>{{ det.zafiro_id }}</span>
                              </td>
                              <td>
                                <div
                                  v-if="
                                    idActualizar == detIndex &&
                                      det.det_solicitud_diaria_id ==
                                        formActualizar.det_solicitud_diaria_id
                                  "
                                >
                                  <div v-if="formActualizar.link_orden_cargue">
                                    <button
                                      type="button"
                                      class="btn btn-sm bg-warning"
                                      @click="eliminarFoto()"
                                    >
                                      <i class="fas fa-trash-alt"></i>
                                    </button>
                                  </div>
                                  <div v-else>
                                    <div v-if="file === null">
                                      <input
                                        type="file"
                                        id="file"
                                        ref="file"
                                        class="form-control-file"
                                        accept=".pdf, .PDF, .jpg, .JPG, .png, .PNG"
                                        @change="elegirDirectorio()"
                                      />
                                    </div>
                                    <div v-else>
                                      <div class="btn-group float-right">
                                        <button
                                          type="button"
                                          class="btn btn-sm bg-warning"
                                          @click="borrarFotoParcial()"
                                        >
                                          <i class="fas fa-trash-alt"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <span v-else>
                                  <div v-if="det.link_orden_cargue">
                                    <button
                                      type="button"
                                      class="btn btn-sm bg-gray-dark"
                                      @click="getImage(det.link_orden_cargue)"
                                    >
                                      <i class="fas fa-image"></i>
                                    </button>
                                  </div>
                                  <div v-else>No hay</div>
                                </span>
                              </td>
                              <td v-if="falgValidando">
                                <div
                                  class="spinner-border text-dark"
                                  role="status"
                                ></div>
                              </td>
                              <td style="width: 50px" class="text-right" v-else>
                                <div
                                  class="btn-group float-right"
                                  v-if="
                                    idActualizar == detIndex &&
                                      det.det_solicitud_diaria_id ==
                                        formActualizar.det_solicitud_diaria_id
                                  "
                                >
                                  <!-- Adiciona postulación -->
                                  <!-- <button
                                    type="button"
                                    class="btn btn-sm bg-success"
                                    v-if="
                                      $store.getters.can(
                                        'hidrocarburos.postulaciones.edit'
                                      ) &&
                                        !$v.formActualizar.$invalid &&
                                        file !== null
                                    "
                                    @click="arreglarForm(det, detIndex)"
                                  >
                                    <i class="fas fa-check-circle"></i>
                                  </button> -->

                                  <button
                                    type="button"
                                    class="btn btn-sm bg-success"
                                    v-if="
                                      $store.getters.can(
                                        'hidrocarburos.postulaciones.edit',
                                      ) && file !== null
                                    "
                                    @click="
                                      validarYGuardar(
                                        det,
                                        detIndex,
                                        postulacion.tipo_ruta,
                                        postulacion.tipo_vehiculo.id,
                                      )
                                    "
                                  >
                                    <i class="fas fa-check-circle"></i>
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-sm bg-info"
                                    @click="getIndex()"
                                  >
                                    <i class="fas fa-sync-alt fa-spin"></i>
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-sm bg-danger"
                                    v-if="
                                      $store.getters.can(
                                        'hidrocarburos.postulaciones.edit',
                                      )
                                    "
                                    @click="limpiarForm()"
                                  >
                                    <i class="fas fa-times-circle"></i>
                                  </button>
                                  <!-- Elimina postulación -->
                                </div>
                                <div class="btn-group float-right" v-else>
                                  <!-- Habilita edición -->
                                  <button
                                    type="button"
                                    class="btn btn-sm bg-navy"
                                    v-if="
                                      $store.getters.can(
                                        'hidrocarburos.postulaciones.edit',
                                      ) &&
                                        (new Date(hoy) <
                                          new Date(
                                            `${postulacion.fecha_cita} ${postulacion.cita}`,
                                          ) ||
                                          $store.getters.can(
                                            'hidrocarburos.postulaciones.editSU',
                                          ))
                                    "
                                    @click="
                                      verFormActualizar(
                                        detIndex,
                                        det,
                                        postulacion,
                                        postulaciones.solicitud_diaria,
                                      )
                                    "
                                  >
                                    <i class="fas fa-edit"></i>
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-sm btn-danger"
                                    v-if="
                                      $store.getters.can(
                                        'hidrocarburos.postulaciones.delete',
                                      ) &&
                                        det.id != null &&
                                        !(
                                          new Date() >
                                          new Date(
                                            `${postulaciones.solicitud_diaria.fecha} ${postulacion.cita}`,
                                          )
                                        ) &&
                                        postulaciones.estado == 1
                                    "
                                    @click="
                                      destroy(det, postulacion.fecha_cita)
                                    "
                                  >
                                    <i class="fas fa-trash-alt"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="alert alert-warning" v-else>
                  <h5>
                    <i class="icon fas fa-exclamation-triangle"></i>
                    Atención!
                  </h5>
                  No se encontraron postulaciones.
                </div>
              </div>
              <!-- Footer moderno -->
              <div class="card-footer bg-gradient-light border-0">
                <div class="row align-items-center">
                  <div class="col-lg-8">
                    <div class="d-flex align-items-center"></div>
                  </div>
                  <div class="col-lg-4 text-end">
                    <div class="d-flex justify-content-end gap-3">
                      <button
                        class="btn btn-outline-secondary btn-lg shadow-sm"
                        @click="back()"
                        style="border-radius: 8px; padding: 12px 24px"
                      >
                        <i class="fas fa-arrow-left me-2"></i>
                        Volver
                      </button>
                      <button
                        class="btn btn-primary btn-lg shadow-sm"
                        @click="back()"
                        style="border-radius: 8px; padding: 12px 24px"
                      >
                        <i class="fas fa-home me-2"></i>
                        Inicio
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "../../../../components/Loading";
import { required } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: "PostulacionForm",
  components: {
    Loading,
  },
  data() {
    return {
      porcentaje: null,
      cargando: false,
      pendientes: 0,
      idSolicitud: null,
      postulaciones: null,
      vigente: 0,
      file: null,
      formActualizar: {
        link_orden_cargue: null,
        zafiro_id: null,
      },
      idActualizar: null,
      distancia: 0,
      empresa_id: null,
      det_postulaciones: [],
      falgValidando: false,
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
      hoy: null,
      manana: null,
    };
  },
  validations() {
    let rem_id = {};
    if (this.formActualizar.tipo_vehiculo_id == 1) {
      rem_id = {
        id: {
          required,
        },
      };
    } else {
      rem_id = {
        id: {
          required: false,
        },
      };
    }

    return {
      formActualizar: {
        vehiculo: {
          id: {
            required,
          },
        },
        remolque: rem_id,
        conductor: {
          id: {
            required,
          },
        },
        orden_cargue: {
          required,
        },
        zafiro_id: {
          required,
        },
      },
    };
  },
  methods: {
    borrarFotoParcial() {
      this.file = null;
    },
    getIndex() {
      this.cargando = true;
      this.idSolicitud = this.$route.params.solicitud_diaria_id;
      this.idSolicitudEmpresa = this.$route.params.solicitud_diaria_empresa_id;
      this.empresa_id = this.$route.params.empresa_id;
      axios
        .get("/api/hidrocarburos/postulaciones/show/" + this.idSolicitud, {
          params: {
            empresa_id: this.empresa_id,
          },
        })
        .then(async (response) => {
          this.postulaciones = response.data[0];
          await this.getPostulaciones(response.data[0]);
          this.pendientes = 0;
          await this.barraPorcentaje();
          this.idActualizar = null;
          this.cargando = false;
        })
    },

    barraPorcentaje() {
      // Calculo de la barra de progreso
      let contador = 0;
      this.postulaciones.solicitud_diaria.det_solicitudes_diarias.forEach(
        (postu) => {
          contador += parseInt(postu.det_postulaciones.length);
          this.pendientes +=
            parseInt(postu.cargues) - parseInt(postu.det_postulaciones.length);
        },
      );

      let carguesDet = this.postulaciones.solicitud_diaria.det_solicitudes_diarias.reduce(
        (acumulador, detSol) => {
          // Verifica si la propiedad cargues existe y es un número
          if ("cargues" in detSol && !isNaN(detSol.cargues)) {
            // Suma el valor de la propiedad cargues al acumulador
            return acumulador + detSol.cargues;
          }
          // Si no existe la propiedad cargues o su valor no es un número, devuelve el acumulador sin cambios
          return acumulador;
        },
        0,
      );

      this.porcentaje =
        (contador /
          parseInt(
            carguesDet,
          )) /*  +
            parseInt(this.postulaciones.cargues_adicional) */ *
        100;
    },

    getPostulaciones(postulaciones) {
      var det_postulacion = new Array();
      postulaciones.solicitud_diaria.det_solicitudes_diarias.forEach(
        (detSolicitud) => {
          let trio_post = new Array();
          for (let i = 0; i < detSolicitud.cargues; i++) {
            let datospost = {
              id: null,
              det_solicitud_diaria_id: detSolicitud.id,
              vehiculo: {
                id: "",
                placa: "",
              },
              remolque: {
                id: "",
                placa: "",
              },
              conductor: {
                id: "",
                numero_documento: "",
                nombres: "",
                apellidos: "",
              },
              orden_cargue: "",
              tipo_vehiculo_id: detSolicitud.tipo_vehiculo_id,
              adicional: detSolicitud.adicional,
            };
            if (detSolicitud.det_postulaciones.length > i) {
              datospost = detSolicitud.det_postulaciones[i];
            }

            trio_post.push(datospost);
          }
          let arr_fin_trio_post = {
            id_det_solicitud: detSolicitud.id,
            data: trio_post,
          };
          det_postulacion.push(arr_fin_trio_post);
        },
      );
      this.det_postulaciones = det_postulacion;
    },

    // Se valida si está a tiempo de realizar postulaciones
    async validarVigencia(det, fecha_cita) {
      this.vigente = 0;
      const fecha = new Date(fecha_cita);
      fecha.setDate(fecha.getDate() + 1);

      let hoy = null;
      let manana = null;

      await axios.get("/api/fecha").then(async (response) => {
        //console.log(response.data);
        hoy = new Date(response.data.hoy);
        manana = new Date(response.data.manana);
      });

      /* console.log(fecha, hoy);
      console.log(manana); */

      //manana.setDate(manana.getDate() + 1);

      if (fecha.getDate() == manana.getDate()) {
        // Se valida la hora permitida de postulaciones
        const hora_validar = hoy.getHours();
        if (hora_validar < 24) {
          this.vigente = 1;
        } else {
          let cita = this.postulaciones.solicitud_diaria.det_solicitudes_diarias.find(
            (post) => post.id === det.det_solicitud_diaria_id,
          ).cita;
          let fecha_hora_cita =
            this.postulaciones.solicitud_diaria.fecha + " " + cita;
          let resvaltiempo = await this.validarTiempo(
            fecha_hora_cita,
            this.postulaciones.solicitud_diaria.sitio.tiempo_maximo_cambio,
            hoy,
          );
          if (resvaltiempo) {
            this.vigente = 1;
          } else {
            this.vigente = 2;
          }
        }
      } else if (fecha.getDate() > manana.getDate()) {
        this.vigente = 1;
      } else if (fecha.getDate() == hoy.getDate()) {
        let cita = this.postulaciones.solicitud_diaria.det_solicitudes_diarias.find(
          (post) => post.id === det.det_solicitud_diaria_id,
        ).cita;
        let fecha_hora_cita =
          this.postulaciones.solicitud_diaria.fecha + " " + cita;
        //console.log(fecha_hora_cita);
        let resvaltiempo = await this.validarTiempo(
          fecha_hora_cita,
          this.postulaciones.solicitud_diaria.sitio.tiempo_maximo_cambio,
          hoy,
        );
        //console.log(resvaltiempo);
        if (resvaltiempo) {
          this.vigente = 1;
        } else {
          if (det.adicional == 1) {
            this.vigente = 1;
          } else {
            this.vigente = 0;
          }
        }
      }

      if (this.$store.getters.can("hidrocarburos.postulaciones.editSU")) {
        this.vigente = 1;
      }
      return this.vigente;
    },

    // Se valida si está a tiempo de realizar ediciones de postulaciones
    validarTiempo(fecha_hora_cita, tiempo_maximo_cambio, hoy) {
      const ahora = hoy;
      const cita = new Date(fecha_hora_cita);
      let diffMs = cita - ahora;
      let diffMins = Math.round(diffMs / 60000);
      //console.log(diffMins);
      if (diffMins > tiempo_maximo_cambio) {
        return true;
      }
      return false;
    },

    saveEstado() {
      this.$swal({
        title: "Está seguro de terminar estas postulaciones?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Terminar!",
      }).then((result) => {
        if (result.value) {
          this.cargando = true;
          let estado = 2;
          let form = {
            id: this.postulaciones.id,
            estado,
          };
          axios({
            method: "PUT",
            url: "/api/hidrocarburos/postulaciones/cambiaEstadoDetSolicitudEmp",
            data: form,
          })
            .then(() => {
              this.postulaciones.estado = 2;
              this.$swal({
                icon: "success",
                title: "La postulación se guardó exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              this.cargando = false;
            })
            .catch((e) => {
              this.$swal({
                icon: "error",
                title: "Ocurrió un error, vuelva a intentarlo..." + e,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              this.cargando = false;
            });
        }
      });
    },

    getImage(url) {
      window.open(this.uri_docs + url, "_blank");
    },

    async eliminarFoto() {
      this.formActualizar.link_orden_cargue = null;
    },

    async buscarVehiculos(tipo_ruta, tipo_vehiculo) {
      this.falgValidando = true;
      let dato = this.formActualizar.vehiculo.placa;
      let res = await this.validarStatus(dato, "V");

      if (res && res.length != 0) {
        // Validaciones combinadas - Solo alertas informativas, no restrictivas
        let mensajeCombinado = "";
        let tieneProblemas = false;

        // Validación de documentación
        if (res.validacion.error) {
          mensajeCombinado +=
            "⚠️ <strong>Advertencia:</strong> El vehículo tiene problemas de documentación<br><br>";

          if (res.validacion.error.documentos !== undefined) {
            if (res.validacion.error.documentos.obligatorios) {
              mensajeCombinado +=
                "📋 <strong>Documentos pendientes:</strong><br>";
              res.validacion.error.documentos.obligatorios.forEach((doc) => {
                mensajeCombinado += `• ${doc}<br>`;
              });
              mensajeCombinado += "<br>";
            }
            if (res.validacion.error.documentos.vencidos) {
              mensajeCombinado +=
                "📅 <strong>Documentos vencidos:</strong><br>";
              res.validacion.error.documentos.vencidos.forEach((doc) => {
                mensajeCombinado += `• ${doc.documento} - Vence: ${doc.fecha_vencimiento}<br>`;
              });
              mensajeCombinado += "<br>";
            }
            if (res.validacion.error.documentos.no_verificados) {
              mensajeCombinado +=
                "❓ <strong>Documentos no verificados:</strong><br>";
              res.validacion.error.documentos.no_verificados.forEach((doc) => {
                mensajeCombinado += `• ${doc}<br>`;
              });
              mensajeCombinado += "<br>";
            }
          } else {
            mensajeCombinado += res.validacion.error.msg;
          }
          tieneProblemas = true;
        }

        //Validacion de inspeccion rechadaza

        if (res["inspeccion_rechazada"]) {
          const inspeccion_id = res["inspeccion_id"];
          const inspeccion_nombre = res["inspeccion_nombre"];
          await this.$swal({
            icon: "error",
            title: "Inspección Rechazada",
            html: `El vehículo <strong>${res[0].placa}</strong> tiene 
           <strong>Inspección rechazada <br> (N° ${inspeccion_id} )</strong> con <strong>(${inspeccion_nombre})</strong> . No es posible postular 
           este vehículo hasta que la inspección sea aprobada o autorizada.`,
            confirmButtonText: "Entendido",
            showCancelButton: false,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        }

        // Validación GPS
        if (res.reporte_gps) {
          const fechaAct = moment().format("YYYY-MM-DD HH:mm:ss");
          const fechaCorte = moment(fechaAct)
            .add(-6, "hours")
            .format("YYYY-MM-DD HH:mm:ss");
          const fechaGps = moment(
            res.reporte_gps.fecha_hora_ultimo_reporte,
          ).format("YYYY-MM-DD HH:mm:ss");

          if (fechaCorte > fechaGps) {
            if (tieneProblemas) {
              mensajeCombinado += "<br>---<br><br>";
            }
            mensajeCombinado +=
              "⚠️ <strong>Advertencia GPS:</strong> El vehículo no ha reportado GPS en las últimas 6 horas. Se recomienda validar con el proveedor.<br>";
            tieneProblemas = true;
          }
        }

        // Validación de registro satelital y distancia
        if (res.ultimoRegistro) {
          if (res.ultimoRegistro.error) {
            // Verificar el tipo de error
            if (res.ultimoRegistro.error.code === -4) {
              // Error en la petición a Google Maps API - No es problema del vehículo
              // Solo mostrar advertencia si hay otros problemas, no bloquear
              if (tieneProblemas) {
                mensajeCombinado += "<br>---<br><br>";
                mensajeCombinado +=
                  "⚠️ <strong>Nota:</strong> No se pudo validar la distancia al sitio (problema temporal con el servicio de mapas).<br>";
              }
            } else {
              // Otros errores GPS sí son problemas del vehículo
              if (tieneProblemas) {
                mensajeCombinado += "<br>---<br><br>";
              }

              // Mostrar mensaje específico según el tipo de error
              if (res.ultimoRegistro.error.msg) {
                if (
                  res.ultimoRegistro.error.msg.includes(
                    "fuera del rango permitido",
                  )
                ) {
                  mensajeCombinado += `⚠️ <strong>Advertencia GPS:</strong> ${res.ultimoRegistro.error.msg}<br>`;
                  tieneProblemas = true;
                } else if (
                  res.ultimoRegistro.error.msg.includes("No se encontro ruta")
                ) {
                  mensajeCombinado +=
                    "No se encontró ruta para el vehículo, se recomienda validar con el proveedor GPS.<br>";
                } else {
                  mensajeCombinado += `⚠️ <strong>Advertencia GPS:</strong> ${res.ultimoRegistro.error.msg}<br>`;
                  tieneProblemas = true;
                }
              }
            }
          } else if (res.ultimoRegistro.success) {
            // GPS funcionando correctamente - NO es un problema
            // Solo mostrar mensaje informativo si ya hay otros problemas
            if (tieneProblemas) {
              mensajeCombinado += "<br>---<br><br>";
              mensajeCombinado += `✅ <strong>GPS OK:</strong> ${res.ultimoRegistro.success.msg} Distancia: ${res.ultimoRegistro.success.distance} Km<br>`;
            }
            // NO marcar tieneProblemas = true cuando el GPS está OK
          }
        } else {
          if (tieneProblemas) {
            mensajeCombinado += "<br>---<br><br>";
          }
          mensajeCombinado +=
            "⚠️ <strong>Advertencia GPS:</strong> El vehículo no tiene integración GPS activa. Se recomienda validar con el proveedor GPS.<br>";
          tieneProblemas = true;
        }

        // Mostrar alerta combinada si hay problemas
        if (tieneProblemas) {
          mensajeCombinado +=
            "<br><em>Se recomienda resolver estos problemas, para continuar con la postulación.</em>";

          await this.$swal({
            html: mensajeCombinado,
            icon: "warning",
            confirmButtonText: "Continuar",
            showCancelButton: false,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        }

        if (res.viaje.length > 0) {
          this.$swal({
            icon: "error",
            title: `El vehículo se encuentra activo dentro de un viaje`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        }

        //Validar si ya se encuentra con una postulacion
        /*  if (res.postulacion.length > 0) {
          this.$swal({
            icon: "error",
            title: `El vehículo cuenta con una postulacion activa`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        }
 */
        //Validar si ya se encuentra con una postulacion adicionales
        if (res.postulacion_adicionales.length > 0) {
          this.$swal({
            icon: "error",
            title: `El vehículo ya está en un proceso de postulacion de adicionales, espere a que este finalice`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 6000,
            timerProgressBar: true,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        }

        //Validar si el vehículo tiene peso asignado.
        if (res[0].peso_vacio == null || res[0].peso_vacio == 0) {
          this.$swal({
            icon: "error",
            title: `El vehículo no tiene peso asignado.`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        }

        if (res["info"] == false) {
          this.$swal({
            icon: "error",
            title: `Hacen falta campos por diligenciar en el formulario de creacion de Vehiculos`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        }

        if (!res["has_lineas"]) {
          this.$swal({
            icon: "error",
            title: `El vehiculo no se encuentra en la linea de negocio Hidrocarburos`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        }

        /* if (!res["linea_gnv"]) {
          this.$swal({
            icon: "error",
            title: `El vehículo tiene combustible a GAS pero no se ha asignado línea vehicular`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        } */

        //Valida el tipo de vehiculo
        if (res[0].tipo_vehiculo_id != tipo_vehiculo) {
          this.$swal({
            icon: "error",
            title: `El tipo de vehículo no coincide.`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        }

        //Valida Si la Empresa del vehiculo tiene check gnv
        /* if (res[0].tipo_combustible == 1) {
          if (res[0].empresa.gnv == null || res[0].empresa.gnv == 0) {
            this.$swal({
              icon: "error",
              title:
                "La Empresa del vehículo no se encuentra habilitada para Gnv.",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
            this.formActualizar.vehiculo = {};
            this.falgValidando = false;
            return false;
          }
        } */

        //Valida el modelo para el trayecto de la ruta larga
        if (tipo_ruta == 2) {
          if (res.modelo) {
            this.formActualizar.vehiculo = res[0];
          } else {
            this.formActualizar.vehiculo = {};
            this.$swal({
              icon: "error",
              title:
                "El vehículo no cumple con las condiciones para ruta larga",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
            this.falgValidando = false;
            return false;
          }
        }

        if (!res["inspeccion_mensual_vencida"]) {
          this.$swal({
            icon: "warning",
            title: "Inspección mensual vencida",
            text:
              "El vehículo tiene una inspección mensual vencida. Se recomienda actualizar la inspección antes de continuar.",
            showCancelButton: true,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
          });
        }

        if (!res["inspeccion_mensual_no"]) {
          this.$swal({
            icon: "warning",
            title: "Sin inspección mensual",
            text:
              "El vehículo no cuenta con una inspección mensual. Se recomienda crear una nueva inspección antes de continuar.",
            showCancelButton: true,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#993C1D",
          });
        }
        //Validar si el vehiculo tiene mas de 15 años en operacion

        let dato = res[0]["placa"];
        let antiguedad = moment().diff(
          moment(res[0]["fecha_matricula"]),
          "years",
        );

        if (res["fecha_matricula_vencida"]) {
          let msg =
            "⚠️ <strong>Advertencia:</strong> El vehiculo con placa " +
            dato +
            "<br> tiene " +
            antiguedad +
            " años y no esta permitido (Maximo 15 años). <br><br>";
          await this.$swal({
            html: msg,
            icon: "warning",
            confirmButtonText: "Continuar",
            showCancelButton: false,
          });
          this.falgValidando = false;
          this.formActualizar.vehiculo = {};
          return false;
        }

        // Asignar vehículo y continuar
        this.formActualizar.vehiculo = res[0];
        this.falgValidando = false;
        return true;
      } else {
        this.$swal({
          icon: "error",
          title:
            "El vehículo digitado NO se encuentra registrado, pruebe con otra placa.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });

        this.falgValidando = false;
        this.formActualizar.vehiculo = {};
        return false;
      }
    },

    async buscarRemolques() {
      this.falgValidando = true;
      let dato = this.formActualizar.remolque
        ? this.formActualizar.remolque.placa
        : null;
      let res = await this.validarStatus(dato, "R");
      if (res && res.length != 0) {
        // Validación de documentación - Solo alertas informativas, no restrictivas
        if (res.validacion.error) {
          let mensajeDoc =
            "⚠️ <strong>Advertencia:</strong> El remolque tiene problemas de documentación<br><br>";

          if (res.validacion.error.documentos !== undefined) {
            if (res.validacion.error.documentos.obligatorios) {
              mensajeDoc += "📋 <strong>Documentos pendientes:</strong><br>";
              res.validacion.error.documentos.obligatorios.forEach((doc) => {
                mensajeDoc += `• ${doc}<br>`;
              });
              mensajeDoc += "<br>";
            }
            if (res.validacion.error.documentos.vencidos) {
              mensajeDoc += "📅 <strong>Documentos vencidos:</strong><br>";
              res.validacion.error.documentos.vencidos.forEach((doc) => {
                mensajeDoc += `• ${doc.documento} - Vence: ${doc.fecha_vencimiento}<br>`;
              });
              mensajeDoc += "<br>";
            }
            if (res.validacion.error.documentos.no_verificados) {
              mensajeDoc +=
                "❓ <strong>Documentos no verificados:</strong><br>";
              res.validacion.error.documentos.no_verificados.forEach((doc) => {
                mensajeDoc += `• ${doc}<br>`;
              });
              mensajeDoc += "<br>";
            }
          } else {
            mensajeDoc += res.validacion.error.msg;
          }

          mensajeDoc +=
            "<br><em>Se recomienda actualizar la documentación, para continuar con la postulación.</em>";

          this.$swal({
            html: mensajeDoc,
            icon: "warning",
            confirmButtonText: "Continuar",
            showCancelButton: false,
          });
          this.formActualizar.remolque = {};
          this.falgValidando = false;
          return false;
        }

        if (res["info"] == false) {
          this.$swal({
            icon: "error",
            title: `Hacen falta campos por diligenciar en el formulario de creacion de Relmoques`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.remolque = {};
          this.falgValidando = false;
          return false;
        }

        if (!res["has_lineas"]) {
          this.$swal({
            icon: "error",
            title: `El Remolque no se encuentra en la linea de negocio Hidrocarburos`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.remolque = {};
          this.falgValidando = false;
          return false;
        }

        if (res.viaje.length > 0) {
          this.$swal({
            icon: "error",
            title: `El remolque se encuentra activo dentro de un viaje`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          //this.formActualizar.remolque = {};
          //this.falgValidando = false;
          //return false;
        }

        if (res.postulacion.length > 0) {
          this.$swal({
            icon: "error",
            title: `El remolque cuenta con una postulacion activa`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.remolque = {};
          this.falgValidando = false;
          return false;
        }

        if (res.postulacion_adicionales.length > 0) {
          this.$swal({
            icon: "error",
            title: `El remolque ya está en un proceso de postulacion de adicionales, espere a que este finalice`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 6000,
            timerProgressBar: true,
          });
          this.falgValidando = false;
          this.formActualizar.remolque = {};
          return false;
        }

        //Validar si el Remolque tiene mas de 15 años en operacion

        let dato = res[0]["placa"];
        let antiguedad = moment().diff(
          moment(res[0]["fecha_matricula"]),
          "years",
        );

        if (res["fecha_matricula_vencida"]) {
          let msg =
            "⚠️ <strong>Advertencia:</strong> El Remolque con placa " +
            dato +
            "<br> tiene " +
            antiguedad +
            " años y no esta permitido (Maximo 15 años). <br><br>";
          await this.$swal({
            html: msg,
            icon: "warning",
            confirmButtonText: "Continuar",
            showCancelButton: false,
          });
          this.falgValidando = false;
          this.formActualizar.remolque = {};
          return false;
        }

        if (res[0].peso_vacio == null || res[0].peso_vacio == 0) {
          this.$swal({
            icon: "error",
            title: `El remolque no tiene peso asignado.`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.remolque = {};
          this.falgValidando = false;
          return false;
        } else {
          this.formActualizar.remolque = res[0];
        }
      } else {
        this.$swal({
          icon: "error",
          title:
            "El remolque digitado NO se encuentra registrado, pruebe con otra placa.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
        this.formActualizar.remolque = {};
        this.falgValidando = false;
        return false;
      }

      this.falgValidando = false;
    },

    async buscarConductores() {
      this.falgValidando = true;
      let dato = this.formActualizar.conductor.numero_documento;
      let res = await this.validarStatus(dato, "C");
      if (res && res.length != 0) {
        // Validación de documentación - Solo alertas informativas, no restrictivas
        if (res.validacion.error) {
          let mensajeDoc =
            "⚠️ <strong>Advertencia:</strong> El conductor tiene problemas de documentación<br><br>";

          if (res.validacion.error.documentos !== undefined) {
            if (res.validacion.error.documentos.obligatorios) {
              mensajeDoc += "📋 <strong>Documentos pendientes:</strong><br>";
              res.validacion.error.documentos.obligatorios.forEach((doc) => {
                mensajeDoc += `• ${doc}<br>`;
              });
              mensajeDoc += "<br>";
            }
            if (res.validacion.error.documentos.vencidos) {
              mensajeDoc += "📅 <strong>Documentos vencidos:</strong><br>";
              res.validacion.error.documentos.vencidos.forEach((doc) => {
                mensajeDoc += `• ${doc.documento} - Vence: ${doc.fecha_vencimiento}<br>`;
              });
              mensajeDoc += "<br>";
            }
            if (res.validacion.error.documentos.no_verificados) {
              mensajeDoc +=
                "❓ <strong>Documentos no verificados:</strong><br>";
              res.validacion.error.documentos.no_verificados.forEach((doc) => {
                mensajeDoc += `• ${doc}<br>`;
              });
              mensajeDoc += "<br>";
            }
          } else {
            mensajeDoc += res.validacion.error.msg;
          }

          mensajeDoc +=
            "<br><em>Se recomienda actualizar la documentación, pero puede continuar con la postulación.</em>";

          this.$swal({
            html: mensajeDoc,
            icon: "warning",
            confirmButtonText: "Continuar",
            showCancelButton: false,
          });
          this.formActualizar.conductor = {};
          this.falgValidando = false;
          return false;
        }

        if (res["info"] == false) {
          this.$swal({
            icon: "error",
            title: `Hacen falta campos por diligenciar en el formulario de creacion de Conductores`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.conductor = {};
          this.falgValidando = false;
          return false;
        }

        /*  if (this.formActualizar.vehiculo.tipo_combustible == 1) {
          if (res[0].gnv == null || res[0].gnv == 0) {
            this.$swal({
              icon: "error",
              title:
                "La Empresa del conductor no se encuentra habilitada para Gnv.",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
            this.formActualizar.conductor = {};
            this.falgValidando = false;
            return false;
          }
        } */

        if (!res["has_lineas"]) {
          this.$swal({
            icon: "error",
            title: `El Conductor no se encuentra en la linea de negocio Hidrocarburos`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.conductor = {};
          this.falgValidando = false;
          return false;
        }

        if (res.viaje.length > 0) {
          if (
            this.formActualizar.estado != 1 &&
            this.formActualizar.estado != 2
          ) {
            this.$swal({
              icon: "error",
              title: `El conductor se encuentra activo dentro de un viaje`,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
            //this.formActualizar.conductor = {};
            //this.falgValidando = false;
            //return false;
          }
        }

        //Valida si se encuentra con una postulación activa
        if (res.postulacion.length > 0) {
          if (
            this.formActualizar.estado != 1 &&
            this.formActualizar.estado != 2
          ) {
            this.$swal({
              icon: "error",
              title: `El conductor cuenta con una postulacion activa`,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
            this.formActualizar.conductor = {};
            this.falgValidando = false;
            return false;
          }
        }

        //Valida si se encuentra con una postulación adicionales
        if (res.postulacion_adicionales.length > 0) {
          this.$swal({
            icon: "error",
            title: `El conductor ya está en un proceso de postulacion de adicionales, espere a que este finalice`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 6000,
            timerProgressBar: true,
          });
          this.formActualizar.conductor = {};
          this.falgValidando = false;
          return false;
        } else {
          this.formActualizar.conductor = res[0];
        }
      } else {
        this.$swal({
          icon: "error",
          title:
            "El conductor digitado NO se encuentra registrado, pruebe con otro documento.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
        this.formActualizar.conductor = {};
        this.falgValidando = false;
        return false;
      }
      this.falgValidando = false;
    },

    // Función msgDocumentacion comentada - COMENTADA
    /*
    async msgDocumentacion(res) {
      if (res.validacion.error) {
        let erroHtml = "<div>";
        if (res.validacion.error.documentos !== undefined) {
          if (res.validacion.error.documentos.obligatorios) {
            erroHtml += "<b>Pendiente:</b><br>";
            erroHtml += res.validacion.error.documentos.obligatorios.join(
              "<br>"
            );
          }
          if (res.validacion.error.documentos.vencidos) {
            erroHtml += "<br><b>Vencidos:</b><br>";
            for (
              let i = 0;
              i < res.validacion.error.documentos.vencidos.length;
              i++
            ) {
              erroHtml +=
                res.validacion.error.documentos.vencidos[i].documento +
                " - " +
                res.validacion.error.documentos.vencidos[i].fecha_vencimiento +
                "<br>";
            }
          }
          if (res.validacion.error.documentos.no_verificados) {
            erroHtml += "<br><b>No Verificados:</b><br>";
            erroHtml += res.validacion.error.documentos.no_verificados.join(
              "<br>"
            );
          }
          erroHtml += "</div>";
          await this.$swal({
            html: erroHtml,
            showCancelButton: false,
            focusConfirm: true,
            icon: "error",
            title: "Aviso en documentacion",
            showConfirmButton: false,
            showCloseButton: true,
            footer:
              "<small style='text-align:center'><b>Desde el 1 de abril se aplicaran las restricciones</b>, por favor tenga al dia la documentacion de sus vehiculos, para mas informacion comuniquese con la mesa de ayuda al siguiente numero <b>3176431376 Opción 3</b></small>",
          });
        } else {
          this.$swal({
            icon: "error",
            title: res.validacion.error.msg,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        }
      }
    },
    */

    async validarYGuardar(det, index, tipo_ruta, tipo_vehiculo) {
      this.falgValidando = true;
      let errores = [];

      await this.buscarVehiculos(tipo_ruta, tipo_vehiculo);

      await this.buscarConductores();
      if (!this.formActualizar.vehiculo?.placa) {
        errores.push("Debe seleccionar un vehículo válido.");
      }

      if (!this.formActualizar.conductor?.numero_documento) {
        errores.push("Debe seleccionar un conductor válido.");
      }

      if (errores.length > 0) {
        this.$swal({
          icon: "error",
          title: "Errores en la validación",
          html: `<ul style="text-align: left;">${errores
            .map((err) => `<li>${err}</li>`)
            .join("")}</ul>`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });

        this.falgValidando = false;
        return;
      }
      this.arreglarForm(det, index);
    },

    async validarStatus(dato, tipo) {
      let me = this;
      let url = "";
      let entidad = null;
      if (tipo == "C") {
        entidad = "Conductor";
        url = "api/hidrocarburos/postulaciones/listaConductores";
      } else if (tipo == "R") {
        entidad = "Remolque";
        url = "api/hidrocarburos/postulaciones/listaRemolques";
      } else if (tipo == "V") {
        entidad = "Vehiculo";
        url = "api/hidrocarburos/postulaciones/listaVehiculos";
      }

      let params = {
        entidad,
        dato,
        fecha: this.postulaciones.solicitud_diaria.fecha,
        sitio_id: this.postulaciones.solicitud_diaria.sitio.id,
        tipo_distancia: 1,
      };

      var res = null;
      await axios
        .get(url, {
          params,
        })
        .then((response) => {
          res = response.data;
        })
        .catch(function(e) {
          me.$swal({
            icon: "error",
            title: "Ocurrió un error - " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
      return res;
    },

    back() {
      const toIndex = () =>
        this.$router.replace({ path: "/Hidrocarburos/Postulaciones" });
      if (this.pendientes != 0 && this.postulaciones.estado === 1) {
        this.$swal({
          title: "Aún no ha realizado todas las postulaciones!",
          text: "¿Está seguro que desea volver?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si, volver!",
        }).then((result) => {
          if (result.value) {
            return toIndex();
          }
        });
      } else {
        return toIndex();
      }
    },

    limpiarForm() {
      this.idActualizar = null;
      this.formActualizar = null;
      this.file = null;
    },

    /**
     * El API puede enviar remolque: null; el template usa formActualizar.remolque.placa.
     * Se reemplaza por un objeto vacío para permitir diligenciar y buscar remolque.
     */
    normalizarFormActualizarDesdeDet(det) {
      const form = { ...det };
      if (form.remolque == null || typeof form.remolque !== "object") {
        form.remolque = { id: null, placa: "" };
      } else {
        form.remolque = {
          ...form.remolque,
          id: form.remolque.id != null ? form.remolque.id : null,
          placa:
            form.remolque.placa != null && form.remolque.placa !== undefined
              ? String(form.remolque.placa)
              : "",
        };
      }
      return form;
    },

    async verFormActualizar(id, det, postulacion, solicitud_diaria) {
      // Se valida si la postulación está en uso
      /* if (det.estado == 2) {
        this.$swal({
          icon: "error",
          title:
            "No se puede modificar la postulación, ya cuenta con un viaje asociado.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
        return;
      } */

      if (!this.$store.getters.can("hidrocarburos.postulaciones.editSU")) {
        let fechaPlena = new Date(
          postulacion.fecha_cita + " " + postulacion.cita,
        );
        const tiempoMaximoArriboEnHoras = Number(
          solicitud_diaria.sitio.tiempo_maximo_arribo,
        );
        fechaPlena.setHours(fechaPlena.getHours() - tiempoMaximoArriboEnHoras);
        if (fechaPlena < new Date()) {
          this.$swal({
            icon: "error",
            title: `Solo se puede modificar la postulación ${tiempoMaximoArriboEnHoras} horas antes de la hora de la cita`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          return;
        }
      }

      det.adicional = postulacion.adicional;
      this.file = null;
      //console.log(det);
      let resvig = await this.validarVigencia(det, postulacion.fecha_cita);

      if (resvig == 2 && det.id !== null) {
        this.idActualizar = id;
        this.formActualizar = this.normalizarFormActualizarDesdeDet({
          ...det,
        });
      } else if (resvig == 1) {
        this.idActualizar = id;
        this.formActualizar = this.normalizarFormActualizarDesdeDet({
          ...det,
        });
      } else {
        this.$swal({
          icon: "error",
          title: "No puede agregar ni modificar la postulación",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
      }
    },

    async arreglarForm(det, index) {
      this.falgValidando = true;

      let form = {
        id: det.id,
        det_solicitud_diaria_id: det.det_solicitud_diaria_id,
        vehiculo_id: this.formActualizar.vehiculo.id,
        /*         remolque_id: this.formActualizar.remolque
          ? this.formActualizar.remolque.id
          : null, */
        conductor_id: this.formActualizar.conductor.id,
        estado: 1,
        orden_cargue: this.formActualizar.orden_cargue,
        link_orden_cargue: this.formActualizar.link_orden_cargue,
      };

      let resSave = await this.save(form);

      if (resSave !== null) {
        this.formActualizar.id = resSave.id;
        this.formActualizar.link_orden_cargue = resSave.link_orden_cargue;
        this.det_postulaciones.find(
          (post) => post.id_det_solicitud === det.det_solicitud_diaria_id,
        ).data[index] = this.formActualizar;

        this.postulaciones.solicitud_diaria.det_solicitudes_diarias
          .find((post) => post.id === det.det_solicitud_diaria_id)
          .det_postulaciones.push(this.formActualizar);

        await this.limpiarForm();
      }

      this.falgValidando = false;
    },

    async save(form) {
      let formData = new FormData();
      formData.append("id", form.id);
      formData.append("det_solicitud_diaria_id", form.det_solicitud_diaria_id);
      formData.append("vehiculo_id", this.formActualizar.vehiculo.id);
      formData.append(
        "remolque_id",
        this.formActualizar.remolque ? this.formActualizar.remolque.id : null,
      );
      formData.append("conductor_id", this.formActualizar.conductor.id);
      formData.append("estado", 1);
      formData.append("orden_cargue", this.formActualizar.orden_cargue);
      formData.append("zafiro_id", this.formActualizar.zafiro_id);
      formData.append("link_orden_cargue", this.file);
      formData.append(
        "link_orden_cargue_text",
        this.formActualizar.link_orden_cargue,
      );
      var res = false;
      await axios
        .post("api/hidrocarburos/postulaciones", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (response) => {
          if (response.data.error !== undefined) {
            this.$swal({
              icon: "error",
              title: response.data.error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            res = null;
            this.formActualizar.zafiro_id = null;
          } else {
            await this.barraPorcentaje();
            res = response.data;
            this.$swal({
              icon: "success",
              title: "La postulación se guardó exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((e) => {
          res = form;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error, vuelva a intentarlo..." + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
      return res;
    },

    async destroy(det, fecha_cita) {
      let resvig = await this.validarVigencia(det, fecha_cita);
      let status = false;
      if (resvig == 2 && det.id !== null) {
        status = true;
      } else if (resvig == 1) {
        status = true;
      } else {
        this.$swal({
          icon: "error",
          title: "No puede agregar ni modificar la postulación",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
      }

      if (status) {
        this.$swal({
          title: "Está seguro de eliminar esta postulación?",
          text: "Los cambios no se pueden revertir!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si, Eliminar!",
        }).then((result) => {
          if (result.value) {
            axios
              .delete("/api/hidrocarburos/postulaciones/" + det.id)
              .then(() => {
                this.getIndex();
                this.$swal({
                  icon: "success",
                  title: "Se eliminó la postulación exitosamente...",
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                });
              });
          }
        });
      }
    },

    elegirDirectorio() {
      let vm = this;
      vm.file = vm.$refs.file[0].files[0];
    },

    enviarCorreo() {
      axios
        .get("/api/hidrocarburos/postulaciones/enviarCorreo", {
          params: {
            solicitud_diaria_id: this.$route.params.solicitud_diaria_id,
            empresa_id: this.$route.params.empresa_id,
          },
        })
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Correo enviado satisfactoriamente",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch(function(error) {
          this.$swal({
            icon: "error",
            title: "Error, en el envio de correo:" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    diasBack() {
      axios.get("/api/fecha").then((response) => {
        //console.log(response.data);
        this.hoy = response.data.hoy;
        this.manana = response.data.manana;
      });
    },
  },

  beforeMount() {
    this.getIndex();
    this.diasBack();
  },
};
</script>
